/* import __COLOCATED_TEMPLATE__ from './direct-deposit-switch-error.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();